<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl z-50">
        <h2 class="text-gray-700 font-bold text-md px-5 py-4 mb-0 mt-0">
          Regitro de SubMódulos del sistema
        </h2>
        <form class="w-full px-5 pb-5" @submit.prevent>
          <label class="block mb-4">
            <span class="text-sm text-gray-600 mb-1 block"> Módulos </span>
            <SelectOptionsModules @send-data="getSelectOptions" />
          </label>
          <label class="block mb-4">
            <span class="text-sm text-gray-600 mb-1 block">
              Descripción del Submódulo
            </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="description"
              placeholder="Descripción..."
            />
          </label>
          <label class="mb-3 block">
            <span class="text-sm text-gray-600 mb-1 block"> URL </span>
            <input
              type="text"
              class="py-2 px-2 text-sm bg-white border outline-none rounded-lg shadow-sm text-gray-600 w-full"
              v-model="urlmenu"
              placeholder="URL del menú..."
            />
          </label>

          <div class="flex">
            <button
              class="bg-red-500 text-white px-2 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-red-600 active:scale-95 w-full mt-3"
              @click="isActive"
              type="button"
            >
              Cancelar
            </button>
            <button
              class="bg-blue-500 text-white px-2 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 w-full mt-3 ml-3"
              @click="insert"
            >
              Registrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SelectOptionsModules from "@/components/SystemModules/SelectOptionsModules.vue";
import { ref } from "vue";
import { confirmationOfRecord, errorActions } from "@/alerts";
import axios from "../../../api";
export default {
  name: "RegisterSubModules",
  components: {
    SelectOptionsModules,
  },
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    function isActive() {
      props.activeModal(true);
    }
    const description = ref("");
    const urlmenu = ref("");
    const systemModules = ref(1);

    //recepcion de datos desde el select hijo
    const getSelectOptions = (data) => {
      systemModules.value = data;
    };

    // onMounted(async()=> {
    //     const response = await axios.get(process.env.VUE_APP_API_URL+'modulos_del_sistema')
    //     console.log(response.data);
    //     registers.value = response.data
    // })

    const insert = async () => {
      if (description.value.trim().length < 4) {
        errorActions(
          "Lo sentimos, no podemos registrar el SubMódulo del sistema, escribe una longitud de caracteres mayor a 3"
        );
        return;
      }
      if (urlmenu.value.trim().length < 4) {
        errorActions(
          "Lo sentimos, no podemos registrar el SubMódulo del sistema, ingresa una URL válida"
        );
        return;
      }
      if (systemModules.value === "") {
        errorActions(
          "Lo sentimos, no podemos registrar el SubMódulo del sistema, Selecciona el módulo principal"
        );
        return;
      }
      const response = await axios
        .post(
          "submodulos_del_sistema",
          {
            idmodulos_del_sistema: systemModules.value,
            descripcion: description.value,
            url_del_modulo: urlmenu.value,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
        });
      const data = await response.data;
      if (data.msg === true) {
        confirmationOfRecord(description.value);
        description.value = "";
        urlmenu.value = "";
        props.getdata();
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
      } else {
        errorActions(
          "Lo sentimos no pudimos realizar el registro del submódulo del sistema"
        );
      }
    };
    return {
      isActive,
      description,
      urlmenu,
      systemModules,
      insert,
      getSelectOptions,
    };
  },
};
</script>
